import type { IWalletEventStrategy } from "@/domains/lock/interfaces"
import type { ManagerStore } from "./manager-store"

/**
 * Manager wallet event strategy that only starts queries when in manager mode.
 * Used by the manager lock orchestrator.
 */
export class ManagerWalletEventStrategy implements IWalletEventStrategy {
  constructor(private readonly managerStore: ManagerStore) {}

  shouldStartQueriesOnWalletConnect(): boolean {
    // Only start queries if we're actually in manager mode
    return this.managerStore.isManagerMode
  }

  shouldStopQueriesOnWalletDisconnect(): boolean {
    // Always stop queries on disconnect
    return true
  }
}

